import { useEffect, useState } from "react";

interface ExploreSnapShot {
  disabledCountdown: number;
  snapDisabled: boolean;
  setSnapDisabled: (snapDisabled: boolean) => void;
  setDisabledCountdown: (disabledCountdown: number) => void;
}

const useExploreSnapShot = (initialCount: number): ExploreSnapShot => {
  const [disabledCountdown, setDisabledCountdown] = useState(initialCount);
  const [snapDisabled, setSnapDisabled] = useState(true);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setDisabledCountdown((prev) => Math.max(prev - 1, 0));
      if (disabledCountdown === 0) {
        setSnapDisabled(false);
        clearInterval(countdownInterval);
      } else {
        setSnapDisabled(true);
      }
    }, 1000);

    return () => {
      clearInterval(countdownInterval);
    };
  }, [disabledCountdown]);

  return { disabledCountdown, snapDisabled, setSnapDisabled, setDisabledCountdown };
};

export default useExploreSnapShot;
